import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content', 'icon', 'trigger']

  connect() {
    const expanded =
      this.triggerTarget.getAttribute('aria-expanded') !== 'false'
    this.applyState(expanded)
  }

  toggle() {
    const expanded = this.triggerTarget.getAttribute('aria-expanded') !== 'true'
    this.applyState(expanded)
  }

  applyState(expanded) {
    this.triggerTarget.setAttribute(
      'aria-expanded',
      expanded ? 'true' : 'false',
    )

    this.iconTarget.classList.toggle('rotate-180', expanded)

    this.contentTarget.classList.toggle('max-h-[200rem]', expanded)
    this.contentTarget.classList.toggle('opacity-100', expanded)
    this.contentTarget.classList.toggle('pointer-events-auto', expanded)

    this.contentTarget.classList.toggle('max-h-0', !expanded)
    this.contentTarget.classList.toggle('opacity-0', !expanded)
    this.contentTarget.classList.toggle('pointer-events-none', !expanded)
    this.contentTarget.toggleAttribute('inert', !expanded)
    this.contentTarget.setAttribute('aria-hidden', expanded ? 'false' : 'true')
  }
}
